module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/startpage_en-199acfc43370e8f76f4528e91b453806.gif";